import { PickerPanel } from 'rc-picker';
import styled from 'styled-components';
import { pickerCommonStyles } from '../../../../pickers/common.styled';
import { WCS } from '../../week-utils';

export const WeekHeaderSC = styled.div`
  height: ${WCS.weekHeaderHeight}px;
  margin: 0 ${WCS.timeLineWidth}px;
  display: flex;
  align-items: center;

  .spacer {
    width: 201px;
    height: 100%;
  }

  .date {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 0 32px 0 0;
    margin: 0 32px;

    /* height: 100%; */

    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 34px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
    color: rgba(24, 30, 53, 0.7);
    opacity: 0.7;
    border: none;
    outline: none;
    background: #fff;
    cursor: pointer;

    .year {
      font-style: normal;
      font-weight: normal;
      margin-left: 8px;
    }

    svg.control {
      margin-left: 8px;
      margin-bottom: 2px;
    }
  }

  .control-strip {
    display: flex;
    align-items: center;
    width: 201px;

    .control {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      outline: none;
      background: rgba(24, 30, 53, 0.1);
      border-radius: 5px;
      cursor: pointer;

      &.left {
        border-radius: 5px 0 0 5px;
      }

      &.right {
        border-radius: 0 5px 5px 0;
      }

      :hover {
        background: rgba(24, 30, 53, 0.15);
      }
    }

    .current-day {
      width: 135px;
      height: 30px;
      padding: 6px;
      margin: 0 3px;
      cursor: pointer;
      border: none;
      outline: none;
      background: rgba(24, 30, 53, 0.1);
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      text-align: center;
      color: #181e34;

      :hover {
        background: rgba(24, 30, 53, 0.15);
      }
    }
  }
`;

export const PickerSC = styled(PickerPanel)`
  ${pickerCommonStyles}
`;
